// extracted by mini-css-extract-plugin
module.exports = {"screen":"Util_screen__1uMwv","icons":"Util_icons__1zonk"};